import { ActionIcon, Button, Group, Menu, Modal, Stack, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconDots, IconDownload, IconTrash, IconUpload } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface UserDocumentSlotActionsProps {
  hasDocument: boolean;
  onDownload: () => void;
  isDownloading: boolean;
  onUpload: () => void;
  onDelete: () => Promise<unknown>;
  isDeleting: boolean;
}

export function UserDocumentSlotActions(props: UserDocumentSlotActionsProps) {
  const { hasDocument, onDownload, isDownloading, onUpload, onDelete, isDeleting } = props;
  const { t } = useTranslation();
  const [confirmOpened, { open: openConfirm, close: closeConfirm }] = useDisclosure(false);

  if (!hasDocument) {
    return (
      <Button
        size="xs"
        variant="outline"
        leftSection={<IconUpload size={14} />}
        onClick={onUpload}
      >
        {t('userDocuments.upload')}
      </Button>
    );
  }

  return (
    <>
      <Menu position="bottom-end">
        <Menu.Target>
          <ActionIcon
            variant="subtle"
            color="gray"
            aria-label={t('userDocuments.actions.menu')}
            loading={isDownloading}
          >
            <IconDots size={16} />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item
            leftSection={<IconDownload size={14} />}
            onClick={onDownload}
          >
            {t('userDocuments.download')}
          </Menu.Item>
          <Menu.Item
            leftSection={<IconUpload size={14} />}
            onClick={onUpload}
          >
            {t('userDocuments.replace')}
          </Menu.Item>
          <Menu.Item
            color="red"
            leftSection={<IconTrash size={14} />}
            onClick={openConfirm}
          >
            {t('button.delete')}
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
      <Modal
        opened={confirmOpened}
        onClose={closeConfirm}
        title={t('userDocuments.actions.confirmDelete.title')}
        centered
      >
        <Stack>
          <Text
            style={{ textAlign: 'center' }}
            fw="500"
          >
            {t('userDocuments.actions.confirmDelete.content')}
          </Text>
          <Group justify="flex-end">
            <Button
              variant="outline"
              onClick={closeConfirm}
              loading={isDeleting}
            >
              {t('button.cancel')}
            </Button>
            <Button
              onClick={() => onDelete().then(closeConfirm)}
              bg="red"
              loading={isDeleting}
              leftSection={<IconTrash size={16} />}
            >
              {t('button.delete')}
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
}
